import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// WhatsApp Web pessoal: o backend decide quem vê (lista de IDs). Menu e rota perguntam aqui.
export default function useWhatsAppWebAcesso() {
  const token = localStorage.getItem('token');
  const { data, isLoading } = useQuery({
    queryKey: ['wa-web-acesso', token],
    queryFn: () => api.get('/whatsapp-web/acesso').then((r) => !!r.data.data?.permitido).catch(() => false),
    enabled: !!token,
    staleTime: Infinity,
  });
  return { permitido: !!data, carregando: isLoading };
}
